import { AppInitializeService } from './core/services/app-initialize.service';

export function initializeAppFactory( appInitializeService: AppInitializeService) {
  return () => appInitializeService.init();
}
